import React from 'react';

export const BookmarkSmall = () => {
    return (
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.76797 5.33334C4.76797 5.11243 4.94705 4.93334 5.16797 4.93334H14.8346C15.0555 4.93334 15.2346 5.11243 15.2346 5.33334V16.5988C15.2346 16.9209 14.8734 17.1109 14.608 16.9284L10.9078 14.3842C10.3618 14.0088 9.64081 14.0088 9.09477 14.3842L5.3946 16.9284C5.1292 17.1109 4.76797 16.9209 4.76797 16.5988V5.33334Z" stroke="white" strokeOpacity="0.4" strokeWidth="1.2"/>
        </svg>
    )
};
